import { render, staticRenderFns } from "./ConfigBackground.vue?vue&type=template&id=26fc5870&scoped=true"
import script from "./ConfigBackground.vue?vue&type=script&lang=js"
export * from "./ConfigBackground.vue?vue&type=script&lang=js"
import style0 from "./ConfigBackground.vue?vue&type=style&index=0&id=26fc5870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fc5870",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VContainer,VDivider,VRow})
